export default __webpack_public_path__ + "static/media/bannerDarkImg.bc3e7ba3.png";